<template>
  <div class="map-share-search d-flex align-center elevation-2">
    <v-text-field
      id="map-share-search-input"
      ref="searchInput"
      v-model="keyword"
      placeholder="Tìm kiếm..."
      hide-details
      dense
      solo
      flat
      clearable
      @click.stop="showHistory = true"
      @focus="showHistory = true"
      @input="showHistory = true"
      @keyup.enter="doSearch"
    >
      <template v-slot:prepend-inner>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          size="20"
          width="2"
          class="mr-1 mt-1"
        ></v-progress-circular>
        <v-icon v-else color="primary" class="mr-1 mt-1">mdi-magnify</v-icon>
      </template>
    </v-text-field>

    <v-menu
      v-model="showHistory"
      offset-y
      nudge-bottom="4"
      :close-on-content-click="false"
      :open-on-click="false"
      eager
      content-class="search-history-menu"
      max-height="250"
      activator="#map-share-search-input"
    >
      <v-list dense v-if="filteredHistory.length > 0">
        <v-list-item
          v-for="(item, index) in filteredHistory"
          :key="index"
          @click="onSelectHistory(item)"
        >
          <v-list-item-icon class="mr-3 my-2">
            <v-icon small color="grey">mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="my-0">
            <v-btn icon small @click.stop="removeHistory(item)">
              <v-icon small color="grey">mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-divider vertical class="mx-1"></v-divider>
    <v-btn icon color="primary" @click="$emit('open-filter')" title="Bộ lọc nâng cao" class="ml-1">
      <v-icon>mdi-filter-variant</v-icon>
    </v-btn>
  </div>
</template>

<script>
const removeDiacritics = (str) => {
  if (!str) return ''
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D')
}

export default {
  name: 'MapShareSearch',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      searchHistory: [],
      showHistory: false,
      HISTORY_KEY: 'map_share_search_history',
      MAX_HISTORY: 100,
      MAX_DISPLAY: 5
    }
  },
  computed: {
    cachedHistory() {
      // Hybrid approach: Precompute normalized strings in RAM whenever searchHistory changes
      return this.searchHistory.map(item => ({
        value: item,
        normalized: removeDiacritics(item.toLowerCase())
      }))
    },
    filteredHistory() {
      if (!this.keyword || !this.keyword.trim()) {
        return this.searchHistory.slice(0, this.MAX_DISPLAY)
      }
      const kw = removeDiacritics(this.keyword.toLowerCase().trim())
      return this.cachedHistory
        .filter(item => item.normalized.includes(kw))
        .map(item => item.value)
        .slice(0, this.MAX_DISPLAY)
    }
  },
  mounted() {
    this.loadHistory()
  },
  methods: {
    loadHistory() {
      try {
        const data = localStorage.getItem(this.HISTORY_KEY)
        if (data) {
          this.searchHistory = JSON.parse(data)
        }
      } catch (err) {
        console.error("Error loading search history", err)
      }
    },
    saveHistory() {
      try {
        localStorage.setItem(this.HISTORY_KEY, JSON.stringify(this.searchHistory))
      } catch (err) {
        console.error("Error saving search history", err)
      }
    },
    addHistory(term) {
      if (!term || !term.trim()) return
      
      const cleanTerm = term.trim()
      
      // Remove if exists to move it to top
      const index = this.searchHistory.findIndex(h => h.toLowerCase() === cleanTerm.toLowerCase())
      if (index !== -1) {
        this.searchHistory.splice(index, 1)
      }
      
      this.searchHistory.unshift(cleanTerm)
      
      if (this.searchHistory.length > this.MAX_HISTORY) {
        this.searchHistory.pop()
      }
      
      this.saveHistory()
    },
    removeHistory(term) {
      this.searchHistory = this.searchHistory.filter(h => h !== term)
      this.saveHistory()
    },
    onSelectHistory(term) {
      this.keyword = term
      this.showHistory = false
      this.doSearch()
    },
    doSearch() {
      if (this.keyword && this.keyword.trim()) {
        // Delay adding to history so the UI doesn't flash before menu closes
        const kw = this.keyword
        setTimeout(() => {
          this.addHistory(kw)
        }, 200)
      }
      this.showHistory = false
      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
      this.$emit('search', this.keyword)
    }
  }
}
</script>

<style scoped>
.map-share-search {
  background: white;
  border-radius: 4px;
  padding: 4px 12px 4px 4px;
  width: 100%;
  max-width: 450px;
}
.map-share-search ::v-deep .v-input__control {
  min-height: 40px !important;
}
.map-share-search ::v-deep .v-input__slot {
  background: transparent !important;
}
</style>
<style>
.search-history-menu {
  border-radius: 4px;
}
</style>
